import { render, staticRenderFns } from "./userNotice.vue?vue&type=template&id=7c66d432&"
import script from "./userNotice.vue?vue&type=script&lang=js&"
export * from "./userNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports